import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout, RequireAuth } from './routes/layout/layout';
import NotFoundPage from './routes/notFoundPage/NotFoundPage';

// Страницы
import About from './pages/About';
import SellingUsedGoods from './pages/SellingGoods';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Advertisers from './pages/Advertisers';
import Agreement from './pages/Agreements';
import FeedbackForm from './pages/FeedbackForm';
import Rules from './pages/Rules';
import Blog from './pages/Blog';
import HomePage from './routes/homePage/homePage';
import ListPage from './routes/listPage/listPage';
import SinglePage from './routes/singlePage/singlePage';
import ProfilePage from './routes/profilePage/profilePage';
import Login from './routes/login/login';
import ForgotPassword from './routes/forgotPassword/forgotPassword';
import UpdatePassword from './routes/updatePassword/updatePassword';
import Register from './routes/register/register';
import ProfileUpdatePage from './routes/profileUpdatePage/profileUpdatePage';
import NewPostPage from './routes/newPostPage/newPostPage';
import CategoryPage from './routes/categoryPage/categoryPage';
import EditPostPage from './routes/editPostPage/editPostPage';
import FavoritePage from './routes/favoritePage/favoritePage';
import ChatsPage from './routes/chatsPage/chatsPage';

// Loaders
import {
  listPageLoader,
  profilePageLoader,
  singlePageLoader,
  editPostPageLoader,
  latestAdsLoader,
  categoryPageLoader,
  favoritePageLoader,
  chatsPageLoader,
} from './lib/loaders';

function App() {
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Восстановление из кэша
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        sessionStorage.setItem('lastVisit', Date.now());
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      errorElement: <NotFoundPage />,
      children: [
        { path: '/', element: <HomePage />, loader: latestAdsLoader },
        { path: '/category/:category', element: <CategoryPage />, loader: categoryPageLoader },
        { path: '/list', element: <ListPage />, loader: listPageLoader },
        { path: '/about', element: <About /> },
         { path: '/blog', element: <Blog /> },
        { path: '/selling-used-goods', element: <SellingUsedGoods /> },
        { path: '/privacy-policy', element: <PrivacyPolicy /> },
        { path: '/advertisers', element: <Advertisers /> },
        { path: '/rules', element: <Rules /> },
        { path: '/agreements', element: <Agreement /> },
        { path: '/feedback', element: <FeedbackForm /> },
        { path: '/login', element: <Login /> },
        { path: '/reset-password', element: <ForgotPassword /> },
        { path: '/reset/:id/:token', element: <UpdatePassword /> },
        { path: '/register', element: <Register /> },
        { path: '/:id', element: <SinglePage />, loader: singlePageLoader },
        { path: '*', element: <NotFoundPage /> },
      ],
    },
    {
      path: '/',
      element: <RequireAuth />,
      errorElement: <NotFoundPage />,
      children: [
        { path: '/profile', element: <ProfilePage />, loader: profilePageLoader },
        { path: '/favorite', element: <FavoritePage />, loader: favoritePageLoader },
        { path: '/mychats', element: <ChatsPage />, loader: chatsPageLoader },
        { path: '/profile/update', element: <ProfileUpdatePage /> },
        { path: '/add', element: <NewPostPage /> },
        { path: '/edit/:id', element: <EditPostPage />, loader: editPostPageLoader },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
